import { all } from 'redux-saga/effects'
import { combineReducers } from 'redux'

export const rootReducer = combineReducers({
  // sin reducers por ahora
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([])
}
